// src/hooks/useBlockedUsers.js

import { useState, useEffect } from 'react';
import { db, auth } from '../config/firebase';
import { doc, onSnapshot, collection, query, where, getDocs } from 'firebase/firestore';

export const useBlockedUsers = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    const userDocRef = doc(db, 'users', currentUser.uid);
    // Listen for changes to the current user's document
    const unsubscribe = onSnapshot(userDocRef, async (userDoc) => {
      const userData = userDoc.data();
      const blockedUsersList = userData?.blockedUsers || [];

      if (blockedUsersList.length > 0) {
        try {
          // Fetch the full profiles for each blocked user UID
          const blockedQuery = query(collection(db, 'users'), where('uid', 'in', blockedUsersList));
          const querySnapshot = await getDocs(blockedQuery);
          const blockedUsersData = [];
          querySnapshot.forEach((doc) => {
            blockedUsersData.push(doc.data());
          });
          setBlockedUsers(blockedUsersData);
        } catch (err) {
          console.error("Error fetching blocked users:", err);
          setBlockedUsers([]);
        }
      } else {
        setBlockedUsers([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return { blockedUsers, loading };
};